import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { IReportState, ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IFiveStarSurveyResponse, IBasicCenterListResponse } from '@nkr/store/index';
import { ICenterFiveStarSurveyType, INetworkFiveStarSurvey, ISortBy, ICenterBase, ICenter, IFiveStartCommentResults, ICenterFiveStarWeightedAverageResults, IAspectType } from '@nkr/models/index';
import { Glyphicon } from 'react-bootstrap';
import { TableWrapper } from './styles';
import NetworkFiveStarSurveyHeaderRow from './network-five-star-survey-header-row';
import NetworkFiveStarSurveyDataRow from './network-five-star-survey-data-row';
import NetworkFiveStarSurveyFilter from './network-five-star-survey-filter';
import NoData from './no-data';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
    centerList: ICenter[]
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getFiveStarSurveyList: (centerId: number, startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => Promise<IFiveStarSurveyResponse>,
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    report: INetworkFiveStarSurvey[],
    weightedAverageResults: ICenterFiveStarWeightedAverageResults[],
    commentResults: IFiveStartCommentResults[],
    centerList: ICenterBase[],
    aspectType: IAspectType,
    sortBy: ISortBy,
    startDate: string,
    endDate: string,
    centerId: number,
    surveyType: ICenterFiveStarSurveyType,
}

class NetworkFiveStarSurveyReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        report: [],
        weightedAverageResults: [],
        commentResults: [],
        sortBy: { property: "centerAlias", direction: "asc" },
        centerList: [],
        aspectType: {
            All: true,
            WorkUp: false,
            PreOp: false,
            SurgeryPlusThree: false,
            SurgeryPlusThirty: false
        },
        startDate: moment().subtract(6, 'months').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        centerId: 0,
        surveyType: {
            dash: false,
            dcn: true,
            nkr: true
        },
    }

    componentDidMount = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(""), { arrayFormat: 'bracket' });
        let startDate = parsed.startDate != null ? parsed.startDate : moment().subtract(6, 'months').format('YYYY-MM-DD');
        let endDate = parsed.endDate != null ? parsed.endDate : moment().format('YYYY-MM-DD');
        let dash = parsed.stype != null ? parsed.stype.indexOf('dash') >= 0 : false;
        let dcn = parsed.stype != null ? parsed.stype.indexOf('dcn') >= 0 : true;
        let nkr = parsed.stype != null ? parsed.stype.indexOf('nkr') >= 0 : true;

        this.setState({
            startDate,
            endDate,
            surveyType: {
                dash,
                dcn,
                nkr
            }
        }, () => {
            this.getData();
        });
    }

    getData = () => {
        let { centerId, startDate, endDate, surveyType } = this.state;

        this.props.showLoading("Getting survey records, one moment please...").then(async () => {
            let centerListResponse = await this.props.getBasicCenterList();

            if (centerListResponse.data.success) {
                this.setState({
                    centerList: centerListResponse.data.results
                });
            }

            this.filter(centerId, startDate, endDate, surveyType);
        });
    }

    filter = (centerId: number, startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => {
        this.props.getFiveStarSurveyList(centerId, startDate, endDate, surveyType)
            .then(response => {
                let { reportResults: report, weightedAverageResults, commentResults } = response.data.results;

                this.setState({
                    report,
                    weightedAverageResults,
                    commentResults,
                }, () => {
                    this.setUrl(startDate, endDate, surveyType);
                });
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    setUrl = (startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => {
        let paramList = [];

        paramList.push(encodeURI('startDate=' + startDate));
        paramList.push(encodeURI('endDate=' + endDate));

        if (surveyType.dash) {
            paramList.push(encodeURI('stype[]=dash'));
        }

        if (surveyType.dcn) {
            paramList.push(encodeURI('stype[]=dcn'));
        }

        if (surveyType.nkr) {
            paramList.push(encodeURI('stype[]=nkr'));
        }

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/network-five-star-surveys?' + params;

        window.history.pushState({}, '', newUrl);
    }

    handleFilterChange = (startDate: string, endDate: string, centerId: number, surveyType: ICenterFiveStarSurveyType) => {
        this.setState({
            startDate,
            endDate,
            surveyType,
            centerId
        });
    }

    handleFilter = () => {
        let { centerId, startDate, endDate, surveyType } = this.state;

        this.props.showLoading("Getting survey data, one moment please...").then(() => {
            this.filter(centerId, startDate, endDate, surveyType);
        });
    }

    getFilteredRow = () => {
        let filteredRows = this.state.report;
        let sortedRows: INetworkFiveStarSurvey = null;
        sortedRows = _.first(filteredRows);

        return sortedRows;
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const results = this.getFilteredRow();
        const weightedAverageResults = _.first(this.state.weightedAverageResults);

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    <NetworkFiveStarSurveyFilter
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        centerId={this.state.centerId}
                        surveyType={this.state.surveyType}
                        centerList={this.state.centerList}
                        isAdmin={this.props.isAdmin}
                        onFilterChange={this.handleFilterChange}
                        onFilter={this.handleFilter}
                    />

                    {results && this.state.commentResults && this.state.report ?
                        <div style={{ width: '100%' }}>
                            <TableWrapper bordered condensed striped style={{ borderTop: 'none', borderRight: 'none' }}>
                                <thead>
                                    <NetworkFiveStarSurveyHeaderRow
                                        detail={results}
                                        detailWeightedAverageResults={weightedAverageResults}
                                    />
                                </thead>

                                <tbody>
                                    {this.state.report.map((item, index) => {
                                        return (
                                            <NetworkFiveStarSurveyDataRow
                                                key={'survey-key'}
                                                detail={item}
                                            />
                                        )
                                    })}
                                </tbody>
                            </TableWrapper>
                        </div>
                        :
                        <NoData message={'No records...'} />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports,
        centerList: appState.centers.list
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getFiveStarSurveyList: (centerId, startDate, endDate, surveyType) => {
            return dispatch(ReportActionCreators.getFiveStarSurvey(centerId, startDate, endDate, surveyType));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(NetworkFiveStarSurveyReport);